import { toModifyVars } from "./utils";
import { totalData as theme5TotalData } from "../theme5";
import commonData from "./data/common";
import treeData from "./data/tree";
import typographyData from "./data/typography";
import upload from "./data/upload";
import buttonData from "./data/button";
import transferData from "./data/transfer";
import tooltipData from "./data/tooltip";
import timelineData from "./data/timeline";
import stepsData from "./data/steps";
import alertData from "./data/alert";
import tagData from "./data/tag";
import tabsData from "./data/tabs";
import collapseData from "./data/collapse";
import tableData from "./data/table";
import modalData from "./data/modal";
import menuData from "./data/menu";
import inputData from "./data/input";
import switchData from "./data/switch";
import { progressData, lineProgressData, circleProgressData } from "./data/progress";
import spinData from "./data/spin";
import performanceTableData from "./data/performanceTable";
import popConfirmData from "./data/popConfirm";
import selectData from "./data/select";
import cardData from "./data/card";
import dropdownData from "./data/dropdown";
var theme2ModifiedData = [commonData, buttonData, transferData, treeData, typographyData, upload, tooltipData, timelineData, cardData, stepsData, alertData, tagData, tabsData, collapseData, tableData, modalData, menuData, inputData, switchData, lineProgressData, circleProgressData, progressData, spinData, performanceTableData, popConfirmData, selectData, dropdownData];
var themeData = toModifyVars(theme5TotalData, theme2ModifiedData);
export default themeData;